import { h } from 'preact';

export const ProportionalImage = ({
    src,
    content = '',
    ratio = 56.25,
    style = {},
    size = '100%',
    ...props
}) => {
    const attrs = {
        role: 'img',
        ariaLabel: content,
        style: {
            paddingTop: `${ratio}%`,
            backgroundSize: size,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url('${src}')`,
            ...style
        }
    }
    
    return (
        <div {...props}>
            <div {...attrs} />
        </div>
    )
}